import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'titleSpace',
    standalone: false
})
export class TitleSpacePipe implements PipeTransform {
  public transform(value: any, ...args: any[]): any {
    return value.replace(/([a-z])([A-Z])/g, '$1 $2');
  }
}
